"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVirtualCategoryBySlug = void 0;
const routes_1 = require("../../routes");
const getVirtualCategoryBySlug = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_VIRTUAL_CATEGORY_BY_SLUG.applyParams(params);
    const response = await client.get(url);
    return response.data;
};
exports.getVirtualCategoryBySlug = getVirtualCategoryBySlug;
